import { render } from "./CitasPorEstado.vue?vue&type=template&id=79014707&scoped=true"
import script from "./CitasPorEstado.vue?vue&type=script&lang=js"
export * from "./CitasPorEstado.vue?vue&type=script&lang=js"

import "./CitasPorEstado.vue?vue&type=style&index=0&id=79014707&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79014707"]])

export default __exports__